module.exports = ":host {\n  height: 100%;\n  width: 100%; }\n\ninput {\n  width: -webkit-fill-available;\n  width: -moz-available;\n  width: stretch; }\n\n.center-checkbox {\n  margin-top: 0;\n  margin-left: 30px; }\n\n.center-header-checkbox {\n  margin-top: 0; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/extracts/components/caloms-extract-workspace.component.scss
// module id = ./src/app/extracts/components/caloms-extract-workspace.component.scss
// module chunks = main